export default "/_next/static/images/8b95a458fc771c5895f6d1bd1d50b773.svg";